import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import './css/Faq.css';

const Faq = ({ numOfFaqs = 10, columnLayout = 'one-column', type = 'Category', tags = [], config }) => {
  const [faqs, setFaqs] = useState([]);
  const [openFaqs, setOpenFaqs] = useState({});

  useEffect(() => {
    const apiUrl = `${config.PY_API_URL}faq`;
    axios.post(apiUrl, { numOfFaqs, type, tags })
      .then(response => {
        const fetchedFaqs = response.data.data.faqs;
        setFaqs(fetchedFaqs);
        // Initialize the open/closed state for each FAQ item to false
        const initialOpenFaqs = fetchedFaqs.reduce((acc, faq, index) => {
          acc[index] = false;
          return acc;
        }, {});
        setOpenFaqs(initialOpenFaqs);
      })
      .catch(error => {
        console.error('Error fetching FAQs:', error);
      });
  }, [numOfFaqs, type, tags]);

  const toggleAnswer = (index) => {
    setOpenFaqs((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div id="mm_faq_block">
      <div className={`elementor-container elementor-column-gap-extended faq-container ${columnLayout}`} style={{ maxWidth: '1200px', margin: 'auto' }}>
        <h4 className='faq-section-title'>{config.title}</h4>
        <div className={`faq-container-${columnLayout}`}>
          {faqs.map((faq, index) => (
            <div className='faq-item-container'>
              <div key={index} className="faq-item">
                <div className="faq-question" onClick={() => toggleAnswer(index)}>
                  <b>{faq.question}</b>
                  <FontAwesomeIcon icon={openFaqs[index] ? faChevronUp : faChevronDown} />
                </div>
                <div className={`faq-answer ${openFaqs[index] ? 'open' : 'closed'}`}>
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
